import { render, staticRenderFns } from "./project-addresses.vue?vue&type=template&id=0406ac53&"
import script from "./project-addresses.vue?vue&type=script&lang=js&"
export * from "./project-addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports